const service =  {
    name: 'ArcticCrowdSource',
    label: 'Arctic Crowd Source',
    permissionId: 'arcticcrowdsource',
    iconComponent: 'SmartIce',
  showCoordinates: true,
  hideDatetimeSlider: true,
  disableMainDate: true,
    data: [],
  layers: [
    {
      name: 'ArcticCrowdSource',
      label: 'Drone imagery',
      opacity: 'raster-opacity',
      datetimeId: 'ArcticCrowdSource',
    },
    // {
    //   name: 'UploadRaster',
    //   label: 'User uploaded imagery',
    //   opacity: 'raster-opacity'
    // },
      {
        name: 'Sentinel1Arctic',
        label: 'Sentinel 1 (75 m)',
        opacity: 'raster-opacity',
        datetimeId: 'Sentinel1Arctic',
        secondary: true
      },
      {
        name: 'Sentinel2Arctic',
        label: 'Sentinel 2 (10 m)',
        opacity: 'raster-opacity',
        datetimeId: 'Sentinel2Arctic',
        secondary: true
      },
      {
        name: 'Modis',
        label: 'Modis (250 m)',
        opacity: 'raster-opacity',
        datetimeId: 'Modis',
        secondary: true
      }
    ],
  locations: [
    // {
    //   name: 'HRL Laboratory',
    //   latitude: 34.04292,
    //   longitude: -118.69577,
    //   zoom: [14]
    // },
    {
      name: 'Floe Edge Pike Island',
      latitude: 63.320,
      longitude: -68.134,
      zoom: [12]
    },
    {
      name: 'River Ice Inuvik',
      latitude: 68.4193,
      longitude: -133.8313,
      zoom: [13]
    },
      // {
      //   name: 'Pond Inlet',
      //   latitude: 68.361667,
      //   longitude: -133.730556,
      //   zoom: [7]
      // },
      // {
      //   name: 'Iqaluit',
      //   latitude: 63.748611,
      //   longitude: -68.519722,
      //   zoom: [10]
      // }
    ]
}

export default service



// WEBPACK FOOTER //
// ./src/services/ArcticCrowdSource.js